<script setup lang="ts">
import { useNetwork } from '@vueuse/core'
import Toast from 'primevue/toast'
import { DotNoConnectionOverlay, LoadingOverlay } from '@/core/components'
import { ChatIncomingToastMessage } from '@/core/components/chat'
import GymAccessToastMessage from '@/modules/gym/components/shared/GymAccessToastMessage.vue'
import { GYM_ACCESS_TOAST_GROUP } from '@/modules/gym/composables/useGymAccessToast'
import { useProvideTheme, useProvideLocale } from '@/core/config'
import { useAuthStore } from './modules/auth'

useProvideTheme()
useProvideLocale()

const { isOnline } = useNetwork()
const auth = useAuthStore()
</script>

<template>
  <div>
    <Toast />
    <Toast position="top-right" group="chatIncoming">
      <template #container="{ message, closeCallback }">
        <ChatIncomingToastMessage
          :message="message"
          :closeCallback="closeCallback"
        />
      </template>
    </Toast>
    <Toast position="top-center" group="errorMessage">
      <template #message="slotProps">
        <div class="flex flex-col items-start flex-auto">
          <div class="flex items-center">
            <span class="font-bold">{{ slotProps.message.summary }}</span>
          </div>
          <ul class="mt-2 space-y-2">
            <li
              v-for="(error, index) in slotProps.message.detail.split(';')"
              :key="index"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </template>
    </Toast>
    <Toast position="top-center" :group="GYM_ACCESS_TOAST_GROUP">
      <template #container="{ message, closeCallback }">
        <GymAccessToastMessage
          :message="message"
          :closeCallback="closeCallback"
        />
      </template>
    </Toast>
    <ConfirmDialog />
    <LoadingOverlay />
    <DotNoConnectionOverlay v-if="!isOnline" />
    <router-view v-if="!auth.loaders.isAuthenticating" />
  </div>
</template>
